// 抄表状态：meterReadingManagement.js

const state = {
    flag: true,  // 控制显示抄表页面还是采集器页面

    menuList: [],

    hasRoutes: false,

    enterPriseList: [],


};
const getters = {
    setMenuList(state, menus) {
        state.menuList = menus
    },
    getEnterPriseList(state) {
        return state.enterPriseList
    }
};
const mutations = {
    // 变换 flag 的值
    changeFlag(state, item) {
        state.flag = item;
    },
    resetState: (state) => {
        state.menuList = []
        state.hasRoutes = false
    },
    changeRouteStatus(state, hasRoutes) {
        state.hasRoutes = hasRoutes
    },
    setEnterPriseList(state, enterPrises) {
        state.enterPriseList = enterPrises
    }
};
const actions = {

};

export default {
    // 用于在全局引用此文件里的方法时标识这一个的文件名
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js